<form [formGroup]="languageForm">
    <div class="fc-language-selector">
        <div class="fc-language-selector-label fcp-text-body-s">
            <label> {{ 'ORG_NOTIFICATIONS.EDIT.LANGUAGE' | translate }}</label>
        </div>
        <fcp-dropdown
            [title]="'ORG_NOTIFICATIONS.EDIT.SELECT_LANGUAGE' | translate"
            [items]="languages"
            [compact]="true"
            [isCustomIcon]="true"
            formControlName="preferredLanguage"
            (close)="onLanguageChange($event)"
        >
            <div class="fc-language-selector-dropdown-icon-container">
                <fcp-icon
                    [icon]="selectedIcon"
                    [isCustom]="true"
                    [style]="'width:16px;height:16px;border-radius:2px'"
                ></fcp-icon>
            </div>
        </fcp-dropdown>
    </div>
</form>
